// Photo URL helper — storage is proxied through the backend (no direct storage URLs).
export const photoSrc = (photoOrId) => {
  if (!photoOrId) return null;
  const id = typeof photoOrId === "string" ? photoOrId : (photoOrId.id || photoOrId.cover_photo_id);
  if (!id) return null;
  return `${process.env.REACT_APP_BACKEND_URL}/api/photos/${id}/file`;
};
